import { useSyncExternalStore } from 'react';

const mobileWidth = '(max-width: 768px)';

const subscribe = (onChange: () => void) => {
  const query = window.matchMedia(mobileWidth);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
};

const getSnapshot = () => window.matchMedia(mobileWidth).matches;

export default () => useSyncExternalStore(subscribe, getSnapshot);
